import * as types from './types'

export default {
  [types.LEAD]: state => {
    return state.leadData
  }
}
